<template>
    <v-container fluid>
        <v-card>
            <v-toolbar dense flat color="secondary">
                <v-toolbar-title>Invoice Preview</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn small text to="/pos/daily/sales">
                    <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
                </v-btn>
            </v-toolbar>

            <v-card-text>

                <v-row>
                    <v-col cols="12" md="12">
                        <v-btn text @click="generateInvoice" color="accent">
                            <v-icon color="black" left>mdi-file-pdf-box</v-icon>Generate
                            Invoice
                        </v-btn>

                        <v-btn text @click="generateDelivery" color="accent">
                            <v-icon color="black" left>mdi-file-pdf-box</v-icon>Generate
                            Delivery
                        </v-btn>

                        <v-btn text @click="generateProformaInvoice" color="accent">
                            <v-icon color="black" left>mdi-file-pdf-box</v-icon>Proforma
                            Invoice
                        </v-btn>

                        <v-btn color="primary" @click="print" text>
                            <v-icon left>mdi-printer</v-icon>Print Receipt
                        </v-btn>

                        <v-btn color="green" @click="shareWhatsApp" text>
                            <v-icon left>mdi-whatsapp</v-icon>Share via WhatsApp
                        </v-btn>

                    </v-col>
                </v-row>

                <v-divider></v-divider>

                <!-- printer div -->
                <div id="print" v-show="showPrinterDiv" style>
                    <!-- section 1 -->
                    <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
                        <div style="text-align: center;">
                            <span style="font-size: 18px; font-weight: bold;">{{ Invoice.Customer &&
                                Invoice.Customer.Name
                            }}</span><br><br>

                        </div>
                    </div>
                    <!-- end -->

                    <div v-for="(item, index) in receiptHeaders" :key="index"
                        style="font-size: 16px; text-align: center;">
                        <div>
                            <span style="text-align: center;"> {{ item.rowText }}</span>

                        </div>
                    </div>
                    <br />

                    <span>-------------------------------------------------------</span>

                    <div>
                        <span class="style-16">Receipt#: {{ Invoice.DocNum }}</span>
                        <br />
                        <span style="font-size: 16px;">Date: {{ Invoice.CreatedAt | date }}</span>
                    </div>

                    <span>-------------------------------------------------------</span>
                    <div
                        style="font-size: 14px; white-space: nowrap; display: flex; justify-content: space-between; font-weight: bold;">
                        <span style="width: 30%; text-align: left; padding-left: 2px;">Item</span>

                        <span style="width: 15%; text-align: left;">Qty</span>

                        <span style="width: 25%; text-align: left;">@</span>

                        <span style="width: 30%; text-align: left; padding-right: 2px;">Total</span>
                    </div>
                    <span>-------------------------------------------------------</span>

                    <div v-for="(item, index) in SaleRows" :key="index" style="font-size: 14px;">
                        <div style="width: 100%; text-align: left; padding-left: 2px; font-weight: bold">{{
                            item.product.Name }}
                        </div>
                        <div
                            style="font-size: 14px; white-space: nowrap; display: flex; justify-content: space-between;">
                            <span style="width: 30%; text-align: left; padding-left: 2px;">(Pcs)</span>

                            <span style="width: 15%; text-align: left;">{{ item.Quantity }}</span>

                            <span style="width: 25%; text-align: left;"> {{ item.Price | currency }}</span>

                            <span style="width: 30%; text-align: left; padding-right: 2px;">{{ item.LineTotal |
                                currency }}</span>
                        </div>
                    </div><br>

                    <span>-------------------------------------------------------</span>

                    <!-- totals -->
                    <div style="font-size: 14px; white-space: nowrap; display: flex; justify-content: space-between;">
                        <span style="width: 50%; text-align: left; padding-left: 2px;">Total Bill</span>

                        <span style="width: 50%; text-align: right; padding-right: 30px;">{{ Invoice && Invoice.DocTotal
                            | currency }}</span>
                    </div>

                    <div style="font-size: 14px; white-space: nowrap; display: flex; justify-content: space-between;">
                        <span style="width: 50%; text-align: left; padding-left: 2px;">Paid</span>

                        <span style="width: 50%; text-align: right; padding-right: 30px;">{{ Invoice && TotalPaid |
                            currency }}</span>
                    </div>

                    <div style="font-size: 14px; white-space: nowrap; display: flex; justify-content: space-between;">
                        <span style="width: 50%; text-align: left; padding-left: 2px;">Balance</span>

                        <span style="width: 50%; text-align: right; padding-right: 30px;">{{ Invoice && Invoice.Balance
                            | currency }}</span>
                    </div>

                    <!-- end -->

                    <span>-------------------------------------------------------</span>


                    <!-- payments -->
                    <div>
                        <span style="font-size: 14px;">Payment Methods</span>
                    </div>

                    <div
                        style="font-size: 14px; white-space: nowrap; display: flex; justify-content: space-between; font-weight: bold;">
                        <span style="width: 50%; text-align: left; padding-left: 2px;">Account</span>

                        <span style="width: 50%; text-align: right; padding-right: 30px;">Amount</span>
                    </div>

                    <div v-for="(item, index) in Payments" :key="index" style="font-size: 16px;">
                        <div
                            style="font-size: 14px; white-space: nowrap; display: flex; justify-content: space-between;">
                            <span style="width: 50%; text-align: left; padding-left: 2px;">{{ item.Account.Name
                                }}</span>

                            <span style="width: 50%; text-align: right; padding-right: 30px;"> {{ item.Amount | currency
                            }}</span>

                        </div>
                    </div>
                    <!-- end -->

                    <span>-------------------------------------------------------</span>

                    <div v-for="(item, index) in receiptFooters" :key="index"
                        style="font-size: 16px; text-align: center;">
                        <div>
                            <span style="text-align: center;"> {{ item.rowText }}</span>

                        </div>
                    </div>

                </div>
                <!-- end of printing div -->

                <v-row class="subtitle-2 text--primary">
                    <v-col cols="12" md="4">
                        <v-simple-table dense>
                            <template v-slot:default>
                                <tbody>
                                    <tr>
                                        <td>Invoice#:</td>
                                        <td>{{ Invoice && Invoice.DocNum }}</td>
                                    </tr>
                                    <tr>
                                        <td>Client:</td>
                                        <td>{{ Invoice.Customer && Invoice.Customer.Name }}</td>
                                    </tr>
                                    <tr>
                                        <td>Total Bill:</td>
                                        <td>{{ Invoice && Invoice.DocTotal | currency }}</td>
                                    </tr>
                                    <tr>
                                        <td>Discount:</td>
                                        <td>{{ Invoice && Invoice.Discount }} %</td>
                                    </tr>
                                    <tr>
                                        <td>Total Paid:</td>
                                        <td>{{ Invoice && TotalPaid | currency }}</td>
                                    </tr>
                                    <tr>
                                        <td>Balance:</td>
                                        <td>{{ Invoice && Balance | currency }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>

                    <v-col cols="12" offset-md="4" md="4">
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">Account</th>
                                        <th class="text-left">Amount Paid</th>
                                        <th class="text-left">Ref No</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in Payments" v-bind:key="index">
                                        <td>{{ item.Account.Name }}</td>
                                        <td>{{ item.Amount | currency }}</td>
                                        <td>{{ item.PaymentRemarks }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>

                <v-divider></v-divider>

                <v-row dense id="po" class="text--primary subtitle-2 mt-2">
                    <v-col cols="12">
                        <v-data-table dense light :mobile-breakpoint="0" :items-per-page="pageItems" :headers="headers"
                            :items="SaleRows" item-key="id" hide-default-footer>
                            <template v-slot:item.Name="{ item }">
                                <span style="width: 200px">{{ item.product.Name }}</span>
                            </template>

                            <template v-slot:item.Quantity="{ item }">
                                {{
                                    item.Quantity
                                }}
                            </template>

                            <template v-slot:item.Price="{ item }">
                                <span v-if="item.Price">{{ item.Price | currency }}</span>
                            </template>

                            <template v-slot:item.DiscSum="{ item }">
                                {{
                                    item.DiscSum
                                }}
                            </template>

                            <template v-slot:item.Discount="{ item }">
                                {{
                                    item.Discount
                                }} %
                            </template>

                            <template v-slot:item.LineTotal="{ item }">
                                {{
                                    item.LineTotal | currency
                                }}
                            </template>
                        </v-data-table>
                    </v-col>

                    <v-col cols="12">
                        <span style="font-size: 16px; font-weight: bold">Outsourced Products</span>
                        <v-data-table light :mobile-breakpoint="0" :items-per-page="pageItems" :headers="outHeaders"
                            :items="OutsourcedProducts" item-key="id" hide-default-footer>
                            <template v-slot:item.Name="{ item }">
                                <span style="width: 200px">{{ item.Name }}</span>
                            </template>

                            <template v-slot:item.ItemCode="{ item }">
                                <span style="width: 200px">{{ item.ItemCode }}</span>
                            </template>

                            <!-- <template v-slot:item.ref1="{ item }">{{item.ref1}}</template> -->

                            <template v-slot:item.Quantity="{ item }">
                                {{
                                    item.Quantity
                                }}
                            </template>

                            <template v-slot:item.Price="{ item }">
                                <span v-if="item.Price">{{ item.Price | currency }}</span>
                            </template>

                            <template v-slot:item.LineTotal="{ item }">
                                {{
                                    item.LineTotal | currency
                                }}
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>

                <!-- snackbar -->
                <snackbar ref="snackbar"></snackbar>
            </v-card-text>
        </v-card>

        <!-- pdf preview -->
        <pdf-preview ref="pdfPreview"></pdf-preview>
        <!-- end -->
    </v-container>
</template>


<script>
import { http, host } from "@/common/index";
export default {
    data: () => ({
        record: {},
        receiptHeaders: [],
        receiptFooters: [],
        showPrinterDiv: false,
        loader: false,
        pageItems: 100,
        Invoice: {},
        TotalPaid: 0,
        Balance: 0,
        OutsourcedProducts: [],
        SaleRows: [],
        Payments: [],
        headers: [
            { text: "Item Code", value: "itemCode" },
            { text: "Product", value: "Name" },
            { text: "Qty", value: "Quantity" },
            { text: "Unit", value: "Unit" },
            { text: "Price", value: "Price" },
            { text: "Discount", value: "Discount" },
            { text: "Total", value: "LineTotal" }
        ],
        outHeaders: [
            { text: "Product", value: "Name" },
            { text: "Qty", value: "Quantity" },
            { text: "Unit", value: "Unit" },
            { text: "Price", value: "Price" },
            { text: "Discount", value: "discount" },
            { text: "Total", value: "LineTotal" }
        ]
    }),
    computed: {
        storeName() {
            return localStorage.getItem("storeName");
        }
    },
    watch: {
        "$route.params.id": {
            handler: "getById",
            immediate: true,
        },
    },
    methods: {
        getById(val) {
            const self = this;
            // get record
            this.$store
                .dispatch("get", `/sales-invoice/${val}`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        var invoice = res.ResponseData;
                        self.Invoice = invoice.Invoice;
                        self.TotalPaid = invoice.TotalPaid;
                        self.Balance = invoice.Balance;
                        self.SaleRows = invoice.SaleRows;
                        self.OutsourcedProducts = invoice.OutsourcedProducts;
                        self.Payments = invoice.Payments;
                    } else {
                        this.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        print() {
            // Get the HTML content you want to print
            const content = document.getElementById("print").innerHTML;

            // Open a new print window
            const printWindow = window.open(
                "",
                "",
                "left=0,top=0,width=100,height=auto,toolbar=0,scrollbars=0,status=0"
            );

            // Write the HTML to the print window, including the content
            printWindow.document.write(`
            <html>
            <head>
                <title>Print</title>
                <style>
                body {
                    width: 80mm;
                    margin: 0 auto;
                }
                @page {
                    size: auto;  /* auto is the current printer page size */
                    margin: 0mm; /* this affects the margin in the printer settings */
                }
                </style>
            </head>
            <body onload="window.print(); window.close();">${content}</body>
            </html>
        `);

            printWindow.document.close();
        },
        shareWhatsApp() {
            const inv = this.Invoice;
            const self = this;

            // Use the same backend endpoint as Generate Invoice
            var isDistributor = localStorage.getItem("IsDistributor");
            var url = "";
            if (isDistributor == "N") {
                url = "/print-sale-invoice-document/14/" + inv.id;
            }
            if (isDistributor == "Y") {
                url = "/print-supermarket-invoice-document/14/" + inv.id;
            }

            const apiUrl = `${host}${url}`;
            self.loader = true;

            http.get(apiUrl, { responseType: "blob" }).then(response => {
                const pdfBlob = new Blob([response.data], { type: "application/pdf" });
                const fileName = `Invoice-${inv.DocNum}.pdf`;
                const pdfFile = new File([pdfBlob], fileName, { type: "application/pdf" });

                if (navigator.canShare && navigator.canShare({ files: [pdfFile] })) {
                    navigator.share({
                        files: [pdfFile],
                        title: `Invoice ${inv.DocNum}`,
                        text: `Invoice #${inv.DocNum} - ${inv.Customer && inv.Customer.Name || ""}`
                    }).catch(() => {});
                } else {
                    // Fallback for desktop: download PDF and open WhatsApp Web
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(pdfBlob);
                    link.download = fileName;
                    link.click();
                    URL.revokeObjectURL(link.href);

                    const message = `Invoice #${inv.DocNum} - ${inv.Customer && inv.Customer.Name || ""}`;
                    window.open(`https://web.whatsapp.com/send?text=${encodeURIComponent(message)}`, "_blank");
                    self.$refs.snackbar.show("PDF downloaded. Please attach it in the WhatsApp chat.", "green");
                }
            }).catch(() => {
                self.$refs.snackbar.show("Failed to generate invoice PDF", "red");
            }).finally(() => {
                self.loader = false;
            });
        },
        generateInvoice() {
            var isDistributor = localStorage.getItem("IsDistributor");
            var url = "";
            if (isDistributor == "N") {
                url = "/print-sale-invoice-document/14/" + this.Invoice.id;
            }

            if (isDistributor == "Y") {
                url = "/print-supermarket-invoice-document/14/" + this.Invoice.id;
            }

            const apiUrl = `${host}${url}`;
            const self = this;
            http.get(apiUrl, { responseType: "blob" }).then(response => {
                const blob = new Blob([response.data], { type: "application/pdf" });
                var fileUrl = URL.createObjectURL(blob);
                console.log(' invoice file url', fileUrl);
                self.$refs.pdfPreview.show(fileUrl);
            });
        },
        generateProformaInvoice() {
            var isDistributor = localStorage.getItem("IsDistributor");
            var url = "";
            if (isDistributor == "N") {
                url = "/print-sale-invoice-document/10/" + this.Invoice.id;
            }

            if (isDistributor == "Y") {
                url = "/print-supermarket-invoice-document/14/" + this.Invoice.id;
            }

            const apiUrl = `${host}${url}`;
            const self = this;
            http.get(apiUrl, { responseType: "blob" }).then(response => {
                const blob = new Blob([response.data], { type: "application/pdf" });
                var fileUrl = URL.createObjectURL(blob);
                console.log(' invoice file url', fileUrl);
                self.$refs.pdfPreview.show(fileUrl);
            });
        },
        generateDelivery() {
            var isDistributor = localStorage.getItem("IsDistributor");
            var url = "";
            if (isDistributor == "N") {
                url = "/print-sale-delivery-document/10/" + this.Invoice.id;
            }

            if (isDistributor == "Y") {
                url = "/print-supermarket-delivery-document/10/" + this.Invoice.id;
            }

            const apiUrl = `${host}${url}`;
            const self = this;
            http.get(apiUrl, { responseType: "blob" }).then(response => {
                const blob = new Blob([response.data], { type: "application/pdf" });
                var fileUrl = URL.createObjectURL(blob);
                self.$refs.pdfPreview.show(fileUrl);
            });
        },
        setDate(date) {
            this.record.DocDate = date;
        },
        getReceiptHeaders() {
            this.$store.commit("btnLoader", false);
            const self = this;
            this.$store
                .dispatch("get", `/get-receipt-headers`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.receiptHeaders = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getReceiptFooters() {
            this.$store.commit("btnLoader", false);
            const self = this;
            this.$store
                .dispatch("get", `/get-receipt-footers`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.receiptFooters = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        // updates
        checkExpiry() {
      const self = this;
      const userId = this.subscriberId;
      this.$store
        .dispatch("get", `/users/${userId}`)
        .then((res) => {
          console.log(res.ResponseData, "res g");
          if (res.ResponseData.expiryStatus == 1) {
            self.$router.push("/inactive-account");
          }
        })
        .catch(() => { });
    },
    },
    created() {
        this.checkExpiry();
        this.getReceiptHeaders();
        this.getReceiptFooters();
    }
};
</script>

<style scoped>
/* .v-text-field__details {
    display: none !important;
  } */
</style>